import { MarketDate } from '@/features/bidding/utils/date/marketDate'

export const MAXIMUM_BIDDABLE_DAYS = 10

export const getFutureDeliveryDays = (): MarketDate[] =>
  Array.from({ length: MAXIMUM_BIDDABLE_DAYS }, (_, i) => new MarketDate().plus({ days: i }))
